import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AILoadingPills = ({
  rows = 4
}) => {
  /**
   * Wanted to render pills of different widths so it looks more like text
   * It is generating numbers 1-4 in multiples of 5 (5, 10 , 15, 20) and subtracting from 100, 90, 80
   * */

  const widths = useMemo(() => {
    return Array.from({
      length: rows
    }, () => {
      return `${100 - (Math.floor(Math.random() * 4) + 1) * 5}%`;
    });
  }, [rows]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: widths.map(width => {
      return /*#__PURE__*/_jsx(AISkeleton, {
        shape: "pill",
        width: width
      }, Math.random());
    })
  });
};
export default AILoadingPills;